module.exports = __webpack_public_path__ + "media/images/rema-1-fde86e813000aae40eefe9aa97b87961.jpg";